var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMailIcono = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.165,
    height: 16.258,
    viewBox: "0 0 22.165 16.258",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-278.809 -809.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.665,23.758H3.484a.987.987,0,0,1-.984-.984V8.5H22.68a.987.987,0,0,1,.984.984Z",
    transform: "translate(276.809 801.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,17l7.851,6L22.7,17",
    transform: "translate(275.137 797.445)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailIcono, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail_icono.07aebb06.svg";
export { ForwardRef as ReactComponent };